import type { CustomerNavItem } from "@scott/ui-d2c/types";
import { COUNTRY_NAVIGATION_BAR_SELECT_LOCATION_URL } from "./constants";

// Cookie expiration constants
const SECONDS_PER_MINUTE = 60;
const MILLISECONDS_PER_SECOND = 1000;

export const getIsCountryNavigationBarVisible = (
  country: string,
  userCountry: string,
  countryNavItem: CustomerNavItem | null,
  countryNavBarCookieValue: string | undefined
) => {
  if (countryNavBarCookieValue === "true" || !countryNavItem) {
    return false;
  }

  const isHeaderCountryDifferentThanUrlCountry =
    country !== userCountry.toLowerCase();
  // @ts-expect-error not today
  const isDataExistent = countryNavItem?.countryLanguageOptions?.length > 0;
  return isHeaderCountryDifferentThanUrlCountry && isDataExistent;
};

export const setCookie = (
  name: string,
  value: string,
  minutes: number
): void => {
  if (typeof document !== "undefined") {
    const expires = new Date();
    expires.setTime(
      expires.getTime() + minutes * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND
    );
    // Using direct document.cookie assignment as this is a client-side utility function
    // In production, consider using a cookie library for better cross-browser support
    // biome-ignore lint/suspicious/noDocumentCookie: Direct assignment needed for client-side utility, consider cookie library in production
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
  }
};

export const getUrlWithSelectedCountryAndLanguage = (
  pathname: string,
  selectedLocationUrl: string
) => {
  const currentUrlSegments = pathname.split("/").filter(Boolean);

  if (selectedLocationUrl === COUNTRY_NAVIGATION_BAR_SELECT_LOCATION_URL) {
    const [currentCountry = "global", currentLanguage = "en"] =
      currentUrlSegments;
    return `/${currentCountry}/${currentLanguage}${selectedLocationUrl}`;
  }

  const selectedCountryAndLanguage = selectedLocationUrl.startsWith("/country")
    ? selectedLocationUrl.slice("/country".length)
    : selectedLocationUrl;

  const selectedCountryAndLanguageSegments = selectedCountryAndLanguage
    .split("/")
    .filter(Boolean);

  const [selectedCountry = "global", selectedLanguage = "en"] =
    selectedCountryAndLanguageSegments;

  const newSegments = [
    selectedCountry,
    selectedLanguage,
    ...currentUrlSegments.slice(2),
  ];

  const newPath = `/${newSegments.join("/")}`;
  return newPath;
};
